import { IClient, IGenericSuccessResponse, IServiceParameter, OneTimeEnum } from "@monorepo/types";

export enum CartStatusesEnum {
  UNPAID = 0,
  PAID = 1,
  PARTIALLY_PAID = 2,
  WAITING_INVOICE = 3,
  UPDATE_DATA = 4,
  SERIVCE_TURNED_OFF = 5,
  PROCEEDING = 6,
  DECLAINED = 7,
  OVERPAID = 8,
  DECLARED = 9,
  STALE = 10,
}

export enum DelayStatusesEnum {
  NON_DELAYED = 0,
  DELAYED = 1,
}

export interface ICartGroup {
  name: string;
  id: string;
  client_id: string;
  confirmed?: boolean;
  is_owner?: boolean;
  owner_name?: string;
  add?: number;
  edit?: number;
  delete?: number;
  shared_clients?: Array<IClient | null>;
}

export interface ICreateCartGroupResponse {
  data: ICartGroup;
}

export interface ICartAttributes {
  amt_calculation: number;
  cart_group_id: number;
  delayed: DelayStatusesEnum;
  parameters: Array<IServiceParameter>;
  reloadable: boolean;
  service_name: string;
  status_id: CartStatusesEnum;
  sum: string;
  id: string;
  customer_number: number;
  category_id: number;
  api_service_name: string;
  sublabel: string;
  one_time?: OneTimeEnum;
  previous_month_unpaid: boolean;
  data_declaration: boolean;
}

export interface ICart extends ICartAttributes {
  service_id: number;
}

export interface IGetCartByIdResponse extends ICartAttributes {
  service_id: number;
}

interface IServiceBase {
  cart_group_id: string;
  service_name: string;
  pay_now: boolean;
  paid: boolean;
  data_declaration?: boolean;
}

export interface IAddServiceToCartPayload extends IServiceBase {
  service_id: string;
  delete_template_id?: string;
  params: {
    [x: string]: string;
  };
}

export interface IUpdateCartPayload extends IServiceBase {
  service_id: null;
  cartId: string;
  barcode: string | null;
  params: {
    [x: string]: string;
  };
}

export interface IUpdateCartResponse {
  data: {
    id: string;
    type: string;
    attributes: ICartAttributes & { service_id: number };
  };
}

export interface IAddServiceToCartResponse {
  data: {
    id: string;
    type: string;
    attributes: ICartAttributes & { service_id: string };
  };
}

export interface IRecurringPaymentPayload {
  addToCart?: boolean;
  cart_group_id: string;
  name: string;
  recipient: string;
  iban: string;
  amount: string;
  purpose: string;
}

export interface IRecurringPayment {
  id: string;
  type: "recurring-payments";
  attributes: {
    client_id: number;
    cart_group_id: number;
    name: string;
    recipient: string;
    iban: string;
    amount: string;
    purpose: string;
    created_at: string;
    updated_at: string;
    deleted_at: string | null;
    available_relationships: Array<string>;
  };
  cart_group_id: string;
  name: string;
  recipient: string;
  iban: string;
  amount: string;
  purpose: string;
}

export interface ITemplatePayload extends ITemplatePayloadBase {
  cart_group_id: string;
}

export interface IEditTemplatePayload extends ITemplatePayloadBase {
  id: string;
  cart_group_id?: string;
}

export interface ITemplatePayloadBase {
  name: string;
  recipient: string;
  iban: string;
  amount: string;
  purpose: string;
  recurring_payment: boolean;
}

export interface IAddTemplateToCartResponse {
  data: {
    id: string;
    type: string;
    attributes: ICart;
  };
}

export interface IAddTemplateResponse {
  data: {
    id: string;
    type: string;
    attributes: ITemplate;
  };
}

export interface IPaynowTemplateResponse {
  data: {
    id: string;
    type: string;
    attributes: ITemplate;
  };
}

export interface ITemplate {
  id: string;
  type: string;
  client_id: number;
  cart_group_id: number;
  updated_at: string;
  created_at: string;
  name: string;
  recipient: string;
  iban: string;
  amount: string;
  purpose: string;
  available_relationships: Array<string>;
}

interface ISharedCartPermissions {
  add: boolean;
  edit: boolean;
  delete: boolean;
}
export interface IShareCartPayload extends ISharedCartPermissions {
  id: number;
  phone: string;
}

export interface IShareCartGenericPayload {
  cart_group_id: string;
  client_id?: string;
}

export interface IShareCartRefuseResponse extends IGenericSuccessResponse {
  cart_group_id: string;
}

export interface IEditCartPermissions extends ISharedCartPermissions {
  cart_group_id: number;
  client_id?: number;
}
